import type { Entity } from '@backstage/catalog-model';

import { stringifyEntityRef } from '@backstage/catalog-model';

/**
 * creates a map of entity ref id to entity
 * @param entities a list of entities
 */
export const associateByEntityRefId = <T extends Entity>(
  entities: readonly T[],
) =>
  entities.reduce(
    (acc, entity) => {
      acc[stringifyEntityRef(entity)] = entity;
      return acc;
    },
    {} as Record<string, T>,
  );
